import { Box, SxProps } from '@mui/material';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { useTokenizedContent } from '../../../hooks/useTokenizedContent';
import { client } from '../../../utils/axios-client';
import { TokenType } from './WysiwygEditor';

function createMarkup(html: string) {
    return {
        __html: DOMPurify.sanitize(html),
    };
}

type Props = {
    html: string;
    sx?: SxProps;
};

const HtmlView = ({ html, sx }: Props) => {
    return <Box sx={{ ...sx }} dangerouslySetInnerHTML={createMarkup(html)}></Box>;
};

export default HtmlView;
